exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@keyframes fadeIn {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.node-selector label {\n  margin-bottom: 0;\n  position: relative;\n  z-index: 1; }\n\n.node-selector .node-selector-list {\n  border: solid 1px #30bced;\n  border-bottom-left-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n  padding-top: 5px;\n  position: relative;\n  top: -5px; }\n\n.node-selector .node-selector-item {\n  padding: 5px 8px; }\n  .node-selector .node-selector-item.highlighted {\n    background-color: rgba(48, 188, 237, 0.4); }\n  .node-selector .node-selector-item.selected {\n    background-color: rgba(119, 65, 219, 0.4); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/StoryEditor/NodeSelector/NodeSelector.scss
// module id = 159
// module chunks = 0